/**
 * EstadosFinancieros.js — página contenedora con tabs
 * Ruta: /finanzas/estados?tab=XXXX
 */
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import BalanceComprobacion from "./BalanceComprobacion";
import EstadoResultados    from "./EstadoResultados";
import BalanceGeneral      from "./BalanceGeneral";
import EstadoFinanciero    from "./EstadoFinanciero";
import { CurrencyProvider } from "../../../../shared/contexts/CurrencyContext";

const TABS = [
  { id: "balance-comprobacion", labelKey: "reportes.balanceComprobacion", icon: "fa-scale-balanced",  component: BalanceComprobacion },
  { id: "estado-resultados",    labelKey: "reportes.estadoResultados",    icon: "fa-chart-line",       component: EstadoResultados    },
  { id: "balance-general",      labelKey: "reportes.balanceGeneral",      icon: "fa-building-columns", component: BalanceGeneral      },
  { id: "estado-financiero",    labelKey: "reportes.estadoFinanciero",    icon: "fa-file-pdf",         component: EstadoFinanciero    },
];

export default function EstadosFinancieros() {
  const { t }     = useTranslation();
  const location  = useLocation();
  const navigate  = useNavigate();

  // Tab puede venir de ?tab=xxx o estar codificado en el pathname (/finanzas/balance-general)
  const _tabFromQS   = new URLSearchParams(location.search).get("tab");
  const _tabFromPath = TABS.find(t => location.pathname === `/finanzas/${t.id}`)?.id;
  const currentTab   = _tabFromQS ?? _tabFromPath ?? TABS[0].id;
  const activeTab    = TABS.find(tab => tab.id === currentTab) ?? TABS[0];
  const ActiveComp = activeTab.component;

  function goTab(id) {
    navigate(`/finanzas/estados?tab=${id}`, { replace: true });
  }

  return (
    <div>
      {/* ── Tab bar ── */}
      <div style={{
        display: "flex",
        gap: 4,
        borderBottom: "1px solid var(--border-card)",
        marginBottom: 24,
        flexWrap: "wrap",
      }}>
        {TABS.map(tab => {
          const active = tab.id === currentTab;
          return (
            <button
              key={tab.id}
              onClick={() => goTab(tab.id)}
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 7,
                padding: "10px 18px",
                background: active ? "rgba(249,115,22,0.12)" : "transparent",
                border: "none",
                borderBottom: active ? "2px solid #f97316" : "2px solid transparent",
                color: active ? "#f97316" : "var(--text-secondary)",
                fontWeight: active ? 700 : 400,
                fontSize: "0.85rem",
                cursor: "pointer",
                transition: "all 0.15s",
                whiteSpace: "nowrap",
                borderRadius: "6px 6px 0 0",
              }}
              onMouseOver={e => { if (!active) e.currentTarget.style.color = "var(--text-primary)"; }}
              onMouseOut={e  => { if (!active) e.currentTarget.style.color = "var(--text-secondary)"; }}
            >
              <i className={`fa-solid ${tab.icon}`} style={{ fontSize: "0.8rem" }} />
              {t(tab.labelKey)}
            </button>
          );
        })}
      </div>

      {/* ── Contenido del tab activo ── */}
      <CurrencyProvider>
        {/* El toggle CRC/USD ahora vive dentro de la barra de filtros de cada
            reporte (junto a período, checkboxes y PDF). La pestaña "Estado
            Financiero" no lo muestra porque solo genera un PDF. */}
        <ActiveComp />
      </CurrencyProvider>
    </div>
  );
}
